import request from './request';

// 获取配置
export function getConfig() {
  return request({
    url: '/config',
    method: 'get'
  });
}

// 更新配置
export function updateConfig(data) {
  return request({
    url: '/config',
    method: 'put',
    data
  });
}

// 测试 OpenRouter API Key
export function testOpenRouterApiKey(apiUrl, apiKey, modelId, useTestPrompt = false) {
  return request({
    url: '/config/test-openrouter',
    method: 'post',
    data: {
      api_url: apiUrl,
      api_key: apiKey,
      model_id: modelId,
      use_test_prompt: useTestPrompt
    }
  });
}

// 测试豆包 API Key
export function testDoubaoApiKey(apiUrl, apiKey, modelId, useTestPrompt = false) {
  return request({
    url: '/config/test-doubao',
    method: 'post',
    data: {
      api_url: apiUrl,
      api_key: apiKey,
      model_id: modelId,
      use_test_prompt: useTestPrompt
    }
  });
}

// 测试 CloudAce API Key
export function testCloudAceApiKey(apiUrl, apiKey, modelId, useTestPrompt = false) {
  return request({
    url: '/config/test-cloudace',
    method: 'post',
    data: {
      api_url: apiUrl,
      api_key: apiKey,
      model_id: modelId,
      use_test_prompt: useTestPrompt
    }
  });
}

// 测试 Google AI Studio API Key
export function testGoogleAiStudioApiKey(apiKey, modelId, useTestPrompt = false) {
  return request({
    url: '/config/test-google-ai-studio',
    method: 'post',
    data: {
      api_key: apiKey,
      model_id: modelId,
      use_test_prompt: useTestPrompt
    }
  });
}

// 测试 Vertex AI API Key
export function testVertexAiApiKey(apiKey, modelId, projectId = null, region = 'us-central1', customEndpoint = null, useTestPrompt = false) {
  return request({
    url: '/config/test-vertex-ai',
    method: 'post',
    data: {
      api_key: apiKey,
      model_id: modelId,
      project_id: projectId,
      region: region,
      custom_endpoint: customEndpoint,
      use_test_prompt: useTestPrompt
    }
  });
}

// 从 OpenRouter 获取模型列表
export function getOpenRouterModels(apiUrl, apiKey) {
  return request({
    url: '/config/openrouter-models',
    method: 'get',
    params: {
      api_url: apiUrl,
      api_key: apiKey
    }
  });
}

// 测试提示词
export function testPrompt(data) {
  return request({
    url: '/config/test-prompt',
    method: 'post',
    data
  });
}

// 测试模型
export function testModel(modelId) {
  return request({
    url: `/config/test-model/${modelId}`,
    method: 'post'
  });
}

